import { render, staticRenderFns } from "./AddFeedDialog.vue?vue&type=template&id=971265ba&"
import script from "./AddFeedDialog.vue?vue&type=script&lang=js&"
export * from "./AddFeedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports